import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";
import { getEligibleMiniDepistages } from "@/utils/miniDepistageUtils";

interface MiniSection7Props {
  data: MiniQuestionnaireData;
  updateDepistages: (depistage: string, checked: boolean) => void;
}

const MiniSection7 = ({ data, updateDepistages }: MiniSection7Props) => {
  const eligibleDepistages = getEligibleMiniDepistages(data);

  const handleCardClick = (depistageId: string) => {
    const isChecked = data.depistages_effectues.includes(depistageId);
    updateDepistages(depistageId, !isChecked);
  };

  if (eligibleDepistages.length === 0) {
    return (
      <div className="space-y-8">
        <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
          Section X – Dépistage
        </h2>
        <p className="text-feel-secondary-foreground">
          Aucun dépistage spécifique n'est recommandé pour votre profil actuel.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Section X – Dépistage
      </h2>

      <p className="text-feel-secondary-foreground mb-6">
        À votre âge, les dépistages suivants sont recommandés : cochez ceux que vous avez déjà réalisés.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {eligibleDepistages.map((depistage) => {
          const isChecked = data.depistages_effectues.includes(depistage.id);
          
          return (
            <Card
              key={depistage.id}
              onClick={() => handleCardClick(depistage.id)}
              className={`
                relative p-4 cursor-pointer transition-all duration-200 
                hover:shadow-md hover:scale-[1.02]
                ${isChecked 
                  ? 'bg-feel-primary/10 border-feel-primary border-2' 
                  : 'bg-feel-card border-feel-border hover:border-feel-primary/50'
                }
              `}
            >
              {isChecked && (
                <div className="absolute top-3 right-3">
                  <div className="w-6 h-6 bg-feel-primary rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                </div>
              )}
              
              <div className="pr-8">
                <h3 className="font-medium text-feel-foreground text-sm mb-1">
                  {depistage.title}
                </h3>
                <p className="text-xs text-feel-secondary-foreground">
                  {depistage.subtitle}
                </p>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MiniSection7;
